module.exports = __webpack_public_path__ + "static/img/egg_g_16.e49ba1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_16.png
// module id = +saU
// module chunks = 1